/**
 * Telefone digitado nos campos de follow-up (teste manual e destinatários).
 *
 * Antes a máscara era brasileira de 11 dígitos e somava 55 sempre: +1, Portugal
 * e Argentina davam "Número inválido", e o contato escolhido da lista
 * (14155550123) virava 5514155550123 (auditoria de 25/09/2026).
 *
 * Regra (a mesma do "Criar contato", via normalizeCreatePhone):
 * - com "+", o operador declarou o país: vale como veio;
 * - sem "+", DDD + número (10 ou 11 dígitos) ganha o 55;
 * - sem "+", 12 a 15 dígitos já trazem o DDI: vale como veio.
 */
import { normalizeCreatePhone } from '../contacts/createPhoneRule';
import { formatPhoneNumber } from '../../utils/wa-personal/chat_utils';

const onlyDigits = (valor) => String(valor || '').replace(/\D/g, '');
const MAX_DIGITS = 15;

/** O campo está no modo brasileiro (sem "+" e até 11 dígitos)? Mostra o "+55". */
export const isBrPhoneInput = (value) => {
  const texto = String(value || '').trim();
  return !texto.startsWith('+') && onlyDigits(texto).length <= 11;
};

/** Máscara do campo enquanto o operador digita. Devolve null quando passou do
 *  tamanho máximo (o campo ignora a tecla). */
export const maskFollowupPhoneInput = (value) => {
  const texto = String(value || '').trimStart();
  const d = onlyDigits(texto);
  if (d.length > MAX_DIGITS) return null;
  if (texto.startsWith('+')) return `+${d}`;
  if (d.length > 11) return `+${d}`;
  if (!d) return '';
  if (d.length <= 2) return `(${d}`;
  if (d.length <= 7) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
};

/** Dígitos para a API (com DDI) ou '' quando o número não é válido. */
export const followupPhoneToRaw = (value) => {
  const texto = String(value || '').trim();
  const d = onlyDigits(texto);
  if (d.length < 10 || d.length > MAX_DIGITS) return '';
  // Sem "+", 10 ou 11 dígitos são DDD + número; menos do que isso não fecha.
  const n = normalizeCreatePhone(texto);
  return n.length >= 10 && n.length <= MAX_DIGITS ? n : '';
};

/** Número gravado (contato escolhido da lista) no campo: sem re-máscara, com
 *  "+" para a leitura voltar os mesmos dígitos. */
export const followupPhoneFromStored = (stored) => {
  const d = onlyDigits(stored);
  if (!d) return '';
  const f = formatPhoneNumber(d);
  return f && String(f).startsWith('+') ? f : `+${d}`;
};
